<template>
  <!-- 资源页 -->
  <div class="header-nav" v-if="$route.path != '/resource/detail'">
    <div class="nav-bg" ref="navBg">
      <el-image :src="require('../../assets/image/resource/res_lovo.png')" fit="fill"></el-image>
    </div>
    <template>
      <div @click="setBarWidth({ref:'ref99999'})" class="header-nva-item" ref="ref99999">全部</div>
      <div :id="item.ref" :key="item.ref" :ref="item.ref" @click="setBarWidth(item)"
           class="header-nva-item" v-for="(item, index) in topList">
        {{ item.title }}
      </div>
    </template>
    <!-- <template v-else>
      <div @click="setHomeBarWidths({ref:'ref99999',name:'首页'})" class="header-nva-item" ref="ref99999">全部</div>
      <div :id="item.ref" :key="item.ref" :ref="item.ref" @click="setHomeBarWidths(item)" class="header-nva-item" v-for="(item, index) in topList">
        {{ item.title }}
      </div>
    </template> -->
  </div>
</template>

<script>
import {getDictDataByType} from '../../api/resource'
export default {
  name: 'PortalHeaderBar',
  data() {
    return {
      topList: [],
      topActive: '',
    };
  },
  async mounted() {
    let data = await this.getByType()
    this.topList = data
    this.init()
  },
  methods: {
    // 获取字库名称
    getByType() {
      return new Promise((provide, inject) => {
        let params = {
          keyName: 'subbase_name',
          typeId: this.$store.state.typeId,
        }
        getDictDataByType(params).then(res => {
          if (res.data.code == 200 && res.data.data) {
            res.data.data.map(e => {
              e.title = e.value
              e.ref = 'refs' + e.code
              return e
            })
            provide(res.data.data)
          }
        })
      })
    },
    init(){
      const path = this.$route.path.split('/')
      const pages = sessionStorage.getItem('pages')
      if(path != '/resource/detail'){
        if(pages){
          const pagesJson = JSON.parse(pages)
          sessionStorage.setItem('sublibrary',JSON.stringify({
            searchName: "sublibrary",
            searchPhrase: "1",
            searchRelation: "1",
            searchType: "0",
            searchValue: pagesJson.name
          }))
          this.$nextTick(() => {
            this.setHomeBarWidth(pagesJson)
          })
        }else{
          sessionStorage.removeItem('sublibrary')
          this.$nextTick(() => {
            this.setHomeBarWidth({ref:'ref99999'})
          })
        }
      }
      if(path[1] == 'resource' && path[2] != 'detail'){
        setTimeout(() => {
          this.$Bus.$emit('sublibrary', {})
        }, 200);
      }
    },
    setHomeBarWidth(item) {
      this.topActive = item.ref
      const fontSize = getComputedStyle(window.document.documentElement)['font-size'].split('px')[0]
      let refs = item.ref
      var t = this.$refs[refs][0] || this.$refs[refs]
      var tem = t.offsetLeft / fontSize
      var widht = t.clientWidth
      var intewidht = parseInt(widht) / fontSize
      var w = this.$refs.navBg
      w.setAttribute('style', ' transform: translateX(' + tem + 'rem);width:' + intewidht + 'rem;');
    },
    setBarWidth(item){
      const path = this.$route.path.split('/')
      this.$store.dispatch('setPages', item)
      sessionStorage.setItem('pages', JSON.stringify(item))
      sessionStorage.setItem('sublibrary',JSON.stringify({
        searchName: "sublibrary",
        searchPhrase: "1",
        searchRelation: "1",
        searchType: "0",
        searchValue: item.title
      }))
      this.$nextTick(() => {
        this.setHomeBarWidth(item)
        if(path[1]=='resource' && path[2] != 'detail'){
          setTimeout(() => {
            this.$Bus.$emit('sublibrary', {})
          }, 200);
        }
      })
      if(path[1]!='index'){
        if(path[2] == 'videoshows' || path[2] == 'detailsAud'){
          sessionStorage.removeItem('category')
          this.$router.push('/resource/all')
          return
        }
        // if(path == '/resource/audio')
        if((path[1]!='resource' && path[2] != 'detail')){
          sessionStorage.removeItem('category')
          this.$router.push('/resource/all')
        }
      }
    }
  },
  computed: {
    routePath() {
      const path = this.$route.path.split('/')
      // const isTure = path[1] == 'resource' && (path[2] == 'inbook' || path[2] == 'author' || path[2] == 'video' || path[2] == 'image' || path[2] == 'audio' || path[2] == 'all')
      const isTure = path[1] == 'resource' && path[1] != 'detail'
      return isTure
    }
  },
  watch:{
    '$route.path':{
      handler:function(newVal,oldVal){
        sessionStorage.removeItem('category')
        if(oldVal.split('/')[2] == 'all' || oldVal.split('/')[2] == 'inbook' || oldVal.split('/')[2] == 'author' || oldVal.split('/')[2] == 'video' || oldVal.split('/')[2] == 'image' || oldVal.split('/')[2] == 'audio' ){
          return
        }
        if((oldVal.split('/')[2] == 'videoshows' || oldVal.split('/')[2] == 'detailsAud') ){
          if(newVal == '/resource/all'){
            sessionStorage.removeItem('category')
            setTimeout(() => {
              this.$Bus.$emit('sublibrary', {})
            }, 200);
          }else{
            return
          }
        }
        this.init()
        if(newVal.split('/')[1] == 'resource' && newVal.split('/')[2] != 'detail'){
          setTimeout(() => {
            this.$Bus.$emit('sublibrary', {})
          }, 200);
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
  .header-nav {
    width: 100%;
    height: 3.646rem;
    background: url('../../assets/image/resource/header_top.png') no-repeat;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.042rem;
    font-weight: bold;
    color: #ffffff;
    // cursor: pointer;
    position: relative;

    .nav-bg {
      position: absolute;
      left: 0;
      width: 16.823rem;
      height: 2.292rem;
      z-index: 1;
      // transition: -webkit-all .3s cubic-bezier(.645, .045, .355, 1);
      // transition: all .3s cubic-bezier(.645, .045, .355, 1);
      // transition: all .3s cubic-bezier(.645, .045, .355, 1), -webkit-all .3s cubic-bezier(.645, .045, .355, 1);
      // -webkit-transition: -webkit-all .3s cubic-bezier(.645, .045, .355, 1);
      transition: transform 0.3s cubic-bezier(.645, .045, .355, 1);
      list-style: none;
      transform: translateX(-100%);
      .el-image {
        width: 100%;
        height: 100%;
      }
    }

    .header-nva-item {
      // margin-right: 2.083rem;
      // padding-left: 1rem;
      padding: 2rem;
      z-index: 2;
      height: 100%;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
  }
</style>
